import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import storePersist from '../../../../../redux/storePersist';
import PageLoader from '../../../../../components/PageLoader';
import { selectSmsConfigurationsQueryItems } from '../../../../../redux/sms-configuration/selector';
import { smsConfigurations } from '../../../../../redux/sms-configuration/action';
import SmsconfigurationsComponent from '../components/sms-configuration.component';



const ManagementSmsConfiguration = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const queryData = useSelector(selectSmsConfigurationsQueryItems)
    const parmas: any = useParams()
    const librariesItems = storePersist?.get("library")?.current;
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedSmsConfigurations,setSelectedSmsConfigurations] = useState<any>([])
    const fetchSmsQueryById = () => {
        dispatch(smsConfigurations.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/sms/query`, entity: 'smsConfigurations', jsonData: {
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })




    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedSmsConfigurations({ ...selectedSmsConfigurations, [fields[0]]: value });

    }
     useEffect(
        () => {
         
    
          if (parmas?.id > 0) {
            fetchSmsQueryById()
                

          } else {
            setIsLoading(false)
          }
    
        },
        []
      )
     useEffect(() => {
       if (isQuery) {
         setSelectedSmsConfigurations(queryData?.result?.items);
         setIsLoading(false)
       }
     }, [isQuery]);


    const handleFormSubmit = async (event: any) => {
        event.preventDefault();


   if (parmas?.id > 0) {
        await dispatch(smsConfigurations.resetAction({ actionType: 'update' }))
        await dispatch(smsConfigurations.update({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/sms`, entity: 'smsConfigurations', jsonData: {
            Records: [
              selectedSmsConfigurations
            ]
  
          }
        })).then(() => {
          back()
        })
  
      } else {
        await dispatch(smsConfigurations.resetAction({ actionType: 'create' }))
        await dispatch(smsConfigurations.create({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/sms`, entity: 'smsConfigurations', jsonData: {
  
            Records: [
              selectedSmsConfigurations
            ]
  
          }
        })).then(() => {
          back()
        })
  
      }
  
    }

    const back = () => {
        navigate('/management/configuration/sms-configurations')
    }
    return (
        <>

            {isLoading ? <PageLoader /> :
                <SmsconfigurationsComponent
                    periods={librariesItems?.MessageDelayPeriod}
                    handleInnerFormChange={handleInnerFormChange}
                    selectedSmsConfigurations={selectedSmsConfigurations}
                    back={back}
                    handleFormSubmit={handleFormSubmit}

                />
            }
        </>
    )

}

export default ManagementSmsConfiguration;